import { render, staticRenderFns } from "./Tarifas.vue?vue&type=template&id=1f5f8d82&scoped=true&"
import script from "./Tarifas.vue?vue&type=script&lang=ts&"
export * from "./Tarifas.vue?vue&type=script&lang=ts&"
import style0 from "./Tarifas.vue?vue&type=style&index=0&id=1f5f8d82&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f5f8d82",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('1f5f8d82', component.options)
    } else {
      api.reload('1f5f8d82', component.options)
    }
    module.hot.accept("./Tarifas.vue?vue&type=template&id=1f5f8d82&scoped=true&", function () {
      api.rerender('1f5f8d82', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Peajes/Tarifas/Tarifas.vue"
export default component.exports